import * as React from 'react';
import { SVGProps } from 'react';

const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path fill={props.fill} d="M10 32.084 14.968 37h14.904v-4.968L10 32.084Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 12.988A9.958 9.958 0 0 1 19.988 3a9.958 9.958 0 0 1 9.988 9.988 9.906 9.906 0 0 1-1.44 5.186l-4.338 7.54-.001.003-1.036 1.814-3.173 5.48-3.176-5.485-1.034-1.81v-.002L11.38 18.06A10.13 10.13 0 0 1 10 12.987Zm9.988-7.918a7.888 7.888 0 0 0-7.918 7.918 8.06 8.06 0 0 0 1.104 4.037v.001l4.4 7.661 1.032 1.807.003.005 1.379 2.38 1.378-2.38.003-.005 1.032-1.807.002-.002 4.354-7.57.008-.012a7.835 7.835 0 0 0 1.14-4.115 7.888 7.888 0 0 0-7.917-7.918Zm-1.553 6.78V8.433h3.105v3.415h3.416v3.105H21.54v3.416h-3.105v-3.416H15.02V11.85h3.415Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgMapPin;
